import { documentConstants } from '../constants';
let user = JSON.parse(localStorage.getItem('PortalUserSettings'));
let subUser = JSON.parse(localStorage.getItem('SubUserSettings'));

let downloadLoadingForDocuments = localStorage.getItem('downloadLoadingForDocuments');

const currentUser = subUser || user || {};
const documentsSettings = (currentUser.gridsSettings || []).filter((item) => item.gridId === 'documents')[0];
const hiddenColumns = (documentsSettings && documentsSettings.visibleColumns) || [];
const initialState = {
	hiddenColumns,
	columnToShowMenu: '',
	downloadLoading: !!downloadLoadingForDocuments,
	downloadFileParams: null,
	emailSent: false,
	emailDownloadFileParams: null
}

export function documents(
	state = initialState,
	action
) {
	switch (action.type) {
		case documentConstants.SET_EMAIL_FAILED_BUT_DOWNLOAD_READY:
			return {
				...state,
				emailDownloadFileParams: action.emailDownloadFileParams
			};
		case documentConstants.SET_EMAIL_SENT:
			return {
				...state,
				emailSent: action.emailSent
			};

		case documentConstants.SET_DOWNLOAD_FILE_PARAMS:
			return {
				...state,
				downloadFileParams: action.downloadFileParams
			};
		case documentConstants.TOGGLE_DOWNLOAD_SPINNER:
			let defaultDownloadStates = {};
			if (action.showSpinner) {
				defaultDownloadStates = {
					downloadFileParams: null,
					emailSent: false,
					emailDownloadFileParams: null
				};
			}
			return {
				...state,
				downloadLoading: action.showSpinner,
				...defaultDownloadStates
			};

		case documentConstants.GET_DOWNLOAD_REQUEST:
			return {
				...state
				//downloadLoading: true
			};
		case documentConstants.GET_DOWNLOAD_SUCCESS:
			return {
				...state
				//downloadLoading: false
			};

		case documentConstants.SET_HIDDEN_COLUMNS:
			return {
				...state,
				hiddenColumns: [ ...action.hiddenColumns ]
			};
		case documentConstants.TOGGLE_SHOW_COLUMN_MENU:
			return {
				...state,
				columnToShowMenu: action.column === state.columnToShowMenu ? '' : action.column
			};
		case documentConstants.TOGGLE_HIDDEN_COLUMNS:
			let hiddenColumns = (state.hiddenColumns || []).slice(0);
			var index = hiddenColumns.indexOf(action.column);
			if (index >= 0) {
				hiddenColumns.splice(index, 1);
			} else {
				hiddenColumns.push(action.column);
			}
			return {
				...state,
				hiddenColumns
			};
		case documentConstants.GETALL_REQUEST:
			return {
				...state,
				items: null,
				loading: true
			};
		case documentConstants.GETALL_SUCCESS:
			return {
				...state,
				items: action.documents,
				TotalPages: action.TotalPages,
				loading: false
			};
		case documentConstants.GETLISTFROMFILE_SUCCESS:
			let newState = {
				...state,
				items: action.documents,
				listFromFileLoaded: !action.withUniqueId,
				withUniqueId: action.withUniqueId,
				TotalPages: action.TotalPages,
				params: action.params,
				loading: false
			};
			if (!action.withUniqueId) newState['filesummary'] = action.filesummary;
			return newState;

		case documentConstants.SET_DOC_LIST_PARAMS:
			var _params = state.params || {};
			_params[action.paramName] = action.paramValue;
			return {
				...state,
				params: _params
			};

		case documentConstants.GETALL_FAILURE:
			return {
				...state,
				error: action.error
				//downloadLoading: false,
			};
		case documentConstants.EXPAND_ROW:
			let updatedList = state.items.map((obj) => {
				if (obj.docnodeid === action.rowId) {
					return Object.assign({}, obj, {
						expanded: !obj.expanded
					});
				}
				return obj;
			});

			return {
				...state,
				items: updatedList
			};
		case documentConstants.SET_ACTIVE_ROW:
			if (state.items && state.items.length) {
				var oldActiveRow = state.items.filter(function(obj) {
					return obj.isActive;
				})[0];

				if (oldActiveRow) {
					oldActiveRow.isActive = false;
				}

				let _item = state.items[action.rowIndex];
				_item.isActive = true;
			}
			return { ...state };
		case documentConstants.CLEAR_DOCUMENTS:
			return {
				...state,
				items: null,
				listFromFileLoaded: false,
				cleared: true
			};
		case documentConstants.RESET_DOCUMENTS:
			return initialState;

		default:
			return state;
	}
}
